// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"4581671c","150":"643d75c2","182":"c17e8fa9","311":"0e6489ca","332":"4bd7641a","705":"b63315fc","731":"d5b249df"}[chunkId] + ".chunk.js";
};